// Confirmation Page
import state from './state.js';

export default function showConfirmation() {
  // Show confirmation UI
}
